var _defs, _rect, _circle, _circle2, _rect2, _rect3, _g, _rect4, _circle3, _line, _rect5, _circle4, _rect6, _rect7, _g2, _rect8, _g3, _rect9, _rect10, _g4, _rect11, _rect12, _g5, _path, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4098EF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4098EF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6",
    stopOpacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 800,
    fill: "url(#g2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 180,
    r: 240,
    fill: "url(#g1)",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 610,
    r: 270,
    fill: "url(#g1)",
    opacity: 0.45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 150,
    width: 780,
    height: 500,
    rx: 22,
    fill: "rgba(0,0,0,0.20)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 180,
    width: 720,
    height: 56,
    rx: 16,
    fill: "rgba(255,255,255,0.10)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0.92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 200,
    width: 26,
    height: 3.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 210,
    width: 26,
    height: 3.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 220,
    width: 26,
    height: 3.5,
    rx: 2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 196,
    width: 360,
    height: 24,
    rx: 12,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 208,
    r: 7,
    fill: "none",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 351,
    y1: 214,
    x2: 360,
    y2: 223,
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 196,
    width: 110,
    height: 24,
    rx: 12,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 846,
    cy: 208,
    r: 7,
    fill: "#4098EF",
    opacity: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 205,
    width: 64,
    height: 6,
    rx: 3,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 252,
    width: 150,
    height: 368,
    rx: 18,
    fill: "rgba(255,255,255,0.10)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 280,
    width: 100,
    height: 44,
    rx: 12,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 294,
    width: 22,
    height: 16,
    rx: 4,
    fill: "#4098EF",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 296,
    width: 44,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 306,
    width: 34,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 336,
    width: 100,
    height: 44,
    rx: 12,
    fill: "rgba(255,255,255,0.04)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 350,
    width: 22,
    height: 16,
    rx: 4,
    fill: "#8B5CF6",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 352,
    width: 48,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 362,
    width: 28,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 392,
    width: 100,
    height: 44,
    rx: 12,
    fill: "rgba(255,255,255,0.04)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 414h18m-8-8l8 8-8 8",
    stroke: "#4098EF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 408,
    width: 50,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 418,
    width: 36,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 448,
    width: 100,
    height: 44,
    rx: 12,
    fill: "rgba(255,255,255,0.04)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 470,
    r: 7,
    fill: "none",
    stroke: "#4098EF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 486c3-7 20-7 23 0",
    fill: "none",
    stroke: "#4098EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 464,
    width: 46,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 474,
    width: 30,
    height: 4.5,
    rx: 2.25,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.9
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 252,
    width: 554,
    height: 368,
    rx: 18,
    fill: "rgba(255,255,255,0.10)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 276,
    width: 168,
    height: 92,
    rx: 16,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 294,
    width: 86,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 315,
    width: 52,
    height: 26,
    rx: 10,
    fill: "#4098EF",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611,
    y: 276,
    width: 168,
    height: 92,
    rx: 16,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627,
    y: 294,
    width: 98,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627,
    y: 315,
    width: 68,
    height: 26,
    rx: 10,
    fill: "#8B5CF6",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 276,
    width: 144,
    height: 92,
    rx: 16,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808,
    y: 294,
    width: 78,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808,
    y: 315,
    width: 56,
    height: 26,
    rx: 10,
    fill: "#4098EF",
    opacity: 0.55
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 386,
    width: 300,
    height: 214,
    rx: 16,
    fill: "rgba(255,255,255,0.04)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 406,
    width: 180,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.9
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 432,
    width: 268,
    height: 28,
    rx: 10,
    fill: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 442,
    width: 64,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 442,
    width: 110,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 441,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#4098EF",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 468,
    width: 268,
    height: 28,
    rx: 10,
    fill: "rgba(255,255,255,0.035)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 478,
    width: 56,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 478,
    width: 120,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 477,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#8B5CF6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 504,
    width: 268,
    height: 28,
    rx: 10,
    fill: "rgba(255,255,255,0.035)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 514,
    width: 62,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 514,
    width: 116,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 513,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#4098EF",
    opacity: 0.55
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 386,
    width: 192,
    height: 214,
    rx: 16,
    fill: "rgba(255,255,255,0.04)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 406,
    width: 120,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.55)",
    opacity: 0.9
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 764,
    y1: 560,
    x2: 924,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    x1: 764,
    y1: 440,
    x2: 764,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    x1: 764,
    y1: 520,
    x2: 924,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    x1: 764,
    y1: 480,
    x2: 924,
    y2: 480
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M772 546 L804 520 L836 528 L868 492 L900 504",
    fill: "none",
    stroke: "#4098EF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#4098EF",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 772,
    cy: 546,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804,
    cy: 520,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 836,
    cy: 528,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 492,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 504,
    r: 4.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.97d3ac3de0d1c73cfd9a74e28c15bdee.svg";
export { ForwardRef as ReactComponent };